import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from "@angular/core";
import { Albo, SpecificheTabellaAlbi, TipiTabellaAlbi } from "src/app/albi-constants";
import { Allegato } from "src/app/entities/Allegato";
import { Pubblicazione } from "src/app/entities/Pubblicazione";
import { CodiceProfiloCommittente } from "src/app/entities/PubblicazioneCommittente";
import { AllegatoService } from "src/app/services/allegato.service";
import { alboFields, profComFields, profComLegge190Fields, provvedimentoAOVRFields } from "./pubblicazione-detail-constants";
import { ExtendedPubblicazione } from "../pubblicazioni-list/extended-pubblicazione";
import { TipoAllegato } from "@bds/internauta-model";

@Component({
  selector: "app-pubblicazione-detail",
  templateUrl: "./pubblicazione-detail.component.html",
  styleUrls: ["./pubblicazione-detail.component.scss"],
  standalone: false,
})
export class PubblicazioneDetailComponent implements OnInit {
  @Input("albo") albo: Albo;
  _pubElement: ExtendedPubblicazione;
  get pubElement(): ExtendedPubblicazione {
    return this._pubElement;
  }

  @Input() set pubElement(value: ExtendedPubblicazione) {
    this._pubElement = value;
    this.publicazioneChanged();
    if (this.fieldsToUse && this._pubElement.pubblicazioneCommittente && this.albo.specifica !== SpecificheTabellaAlbi.LEGGE190) {
      this.checkAndUpdateFieldsToUse();
    }
  }

  @Output("closeRightPanel") closeRightPanel = new EventEmitter();
  @ViewChild("anteprima") private anteprima: ElementRef;

  public allegati: Allegato[];
  allegatoSelezionato: any;
  public noAnteprima: boolean = false;
  public rowChanged: boolean;
  public fieldsToUse: any[];
  public linkBDNCPSSplittato = [];
  public linkIntercentSplittato = [];

  constructor(private allegatoService: AllegatoService) {}

  ngOnInit(): void {
    this.loadFieldsToUse();
  }
  public loadFieldsToUse() {
    switch (this.albo.tipo) {
      case TipiTabellaAlbi.ALBO:
        this.fieldsToUse = alboFields;
        this.filterAllegatoFromPeriodo();
        break;
      case TipiTabellaAlbi.PROFILO_COMMITTENTE:
        if (this.albo.specifica === SpecificheTabellaAlbi.LEGGE190) {
          this.fieldsToUse = profComLegge190Fields;
        } else {
          this.fieldsToUse = profComFields;
          this.checkAndUpdateFieldsToUse();
        }
        break;
      case TipiTabellaAlbi.PROVVEDIMENTI:
        if (this.albo.azienda === "aouivr") {
          this.fieldsToUse = provvedimentoAOVRFields;
          console.log(this.fieldsToUse);
          console.log(this.pubElement);
          this.filterAllegatoFromPeriodo();
        }
        break;
    }
  }
  /*
    This is from the Old ALBO don't know which fields should take the neccessery names;
    Cambio le etichette per questi due campi se la pubblicazione viene da Pico
  */
  public checkAndUpdateFieldsToUse() {
    if (
      this.pubElement.pubblicazioneCommittente.codiceProfiloCommittente === CodiceProfiloCommittente.Esito_di_procedura_procton ||
      this.pubElement.pubblicazioneCommittente.codiceProfiloCommittente === "nota_a_contrarre_procton"
    ) {
      this.fieldsToUse.find((c) => c.field == "cig").header = "CIG";
      this.fieldsToUse.find((c) => c.field == "importo").header = "Importo senza IVA";
    } else {
      this.fieldsToUse.find((c) => c.field == "cig").header = "CIG Accordo quadro";
      this.fieldsToUse.find((c) => c.field == "importo").header = "Importo";
    }
  }
  /*
    Function to initialize Anteprima when the row is selected/changed
  */
  public publicazioneChanged() {
    this.rowChanged = true;
    if (this.pubElement.allegatiList.length != 0) {
      // Qui devo avere solo l'ultimo allegato LEGGE190 e non i precedenti
      // Idealmente avrebbe dovuto essere creata una pubblicazione partendo da un gddoc
      // con un solo sotto_documento LEGGE190 ma lato InDe non siamo riusciti.
      const allegatiLegge190 = this.pubElement.allegatiList
        .filter((a) => a.tipoAllegato === "LEGGE190")
        .sort((a, b) => b.nomeAllegato.localeCompare(a.nomeAllegato));

      const altriAllegati = this.pubElement.allegatiList
        .filter((a) => a.tipoAllegato !== "LEGGE190")
        .sort((a, b) => a.tipoAllegato.localeCompare(b.tipoAllegato));

      if (allegatiLegge190.length > 0) {
        allegatiLegge190[0].nomeAllegato =
          "LEGGE_190_" +
          this.pubElement.tipiDocumentiList[0].registro +
          this.pubElement.numeroRegistroVisualizzazione +
          "_" +
          this.pubElement.tipiDocumentiList[0].annoRegistro +
          allegatiLegge190[0].nomeAllegato.slice(-4);
      }

      this.pubElement.allegatiList = [...allegatiLegge190.slice(0, 1), ...altriAllegati];
      //setto la stampa unica come primo allegato visualizzato
      this.allegatoSelezionato = this.getStampaUnica();
      if (this.pubElement.pubblicazioneCommittente && this.pubElement.pubblicazioneCommittente.linkBdncp) {
        // this.pubElement.linkBDNCPVisualizzazione = this.pubElement.pubblicazioneCommittente.linkBdncp.split(";");
        this.linkBDNCPSSplittato = this.pubElement.pubblicazioneCommittente.linkBdncp.split(";");
      }
      if (this.pubElement.pubblicazioneCommittente && this.pubElement.pubblicazioneCommittente.linkIntercent) {
        this.linkIntercentSplittato = this.pubElement.pubblicazioneCommittente.linkIntercent.split(";");
      }
      this.setAnteprimaUrl();
    }
  }
  //function that might be used in future!
  //public downloadAllegati(allegatiEl: Allegato){
  // console.log(allegatiEl);
  //  }

  //function to display the allegato when selected
  public allegatoSelected(event: any) {
    console.log("string", event);
    if (event && event.value) {
      this.allegatoSelezionato = event.value;
      this.setAnteprimaUrl();
    } else {
      this.allegatoSelezionato = null;
    }
  }

  fullscreen(event: any) {
    const iframeElement: any = this.anteprima.nativeElement;
    const fullScreenFunction =
      iframeElement.requestFullscreen ||
      iframeElement.webkitRequestFullscreen ||
      iframeElement.mozRequestFullScreen ||
      iframeElement.msRequestFullscreen;
    fullScreenFunction.call(iframeElement);
  }

  public setAnteprimaUrl() {
    /* if ( this.attivitaSelezionata.idApplicazione.id === "dete" && this.attivitaSelezionata.descrizione === "Bozza" ) {
      this.noAnteprima = true;
    } else { */
    this.rowChanged = false;
    this.noAnteprima = false;
    this.allegatoService.downloadAllegatoFile(this.allegatoSelezionato).subscribe({
      next: (file) => {
        //console.log(file);
        this.anteprima.nativeElement.src = URL.createObjectURL(file);
      },
      error: () => {
        this.noAnteprima = true;
      },
    });
    /*  } */
  }

  public filterAllegatoFromPeriodo() {
    this.pubElement.allegatiList = this.pubElement.allegatiList.filter((al) => {
      switch (al.tipoAllegato) {
        case "RELATA":
          if (this.pubElement.periodoPubblicazioneList.find((pr) => pr["fk_idRelata"].id === al.id)) {
            return true;
          } else {
            return false;
          }
        case "STAMPA_UNICA":
          return true;
        case "LEGGE190":
          return true;
      }
    });
  }

  /**
   * funzione che prende la stampa unica dalla lista degli allegati
   */
  public getStampaUnica(): Allegato {
    const stampaUnicaArray = this.pubElement.allegatiList.filter(
      (allegato) => allegato.tipoAllegato === TipoAllegato.STAMPA_UNICA
    );
    if (stampaUnicaArray.length > 1) {
      console.log("Errore: sono stati trovati due allegati di tipo Stampa Unica");
    }
    return stampaUnicaArray[0];
  }
}
